import Script from 'next/script';
import React, { useEffect } from 'react';
import { Nullish } from 'shared-types';
import * as R from 'remeda';
import { useScrollDepthTracker } from '@features/analytics/components/AnalyticsScripts/ScrollDepthTracker/useScrollDepthTracker';
import { analytics } from '@features/analytics/utilities/analytics';

type AnalyticsScriptsProps = {
  googleAnalyticsIds?: Array<Nullish<string>>;
  googleTagManagerIds?: Array<Nullish<`GTM-${string}` | string>>;
};

export function AnalyticsScripts({
  googleAnalyticsIds = [],
  googleTagManagerIds = [],
}: AnalyticsScriptsProps) {
  const notNullishGoogleAnalyticsIds = R.filter(googleAnalyticsIds, R.isTruthy);
  const notNullishGoogleTagManagerIds = R.filter(googleTagManagerIds, R.isTruthy);

  useScrollDepthTracker();

  useEffect(() => {
    analytics.markReady();
  }, []);

  return (
    <>
      {notNullishGoogleAnalyticsIds.map((googleAnalyticsId) => (
        <React.Fragment key={googleAnalyticsId}>
          <Script
            data-testid={`ga-script-${googleAnalyticsId}`}
            src={`https://www.googletagmanager.com/gtag/js?id=${googleAnalyticsId}`}
            strategy="afterInteractive"
          />
          <Script strategy="afterInteractive">
            {`
              window.dataLayer = window.dataLayer || [];
              function gtag(){window.dataLayer.push(arguments);}
              gtag('js', new Date());

              gtag('config', '${googleAnalyticsId}');
            `}
          </Script>
        </React.Fragment>
      ))}

      {notNullishGoogleTagManagerIds.map((googleTagManagerId) => (
        <Script
          key={googleTagManagerId}
          strategy="afterInteractive"
          data-testid={`gtm-script-${googleTagManagerId}`}
        >
          {`
            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','${googleTagManagerId}');
          `}
        </Script>
      ))}
    </>
  );
}
